import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TEXT = "We don't do good enough. We don't do that'll pass. We clean homes and businesses until they're so clean it's honestly a little offensive.";

const Word = ({ word, i, total, progress }) => {
  const start = i / total;
  const opacity = useTransform(progress, [start, start + 1 / total], [0.5, 1]);
  return <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">{word}</motion.span>;
};

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = TEXT.split(" ");
  return (
    <section ref={ref} className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-36" data-testid="manifesto-section">
      <p className="eyebrow mb-10">( The attitude )</p>
      <p className="max-w-6xl text-3xl font-semibold leading-[1.15] tracking-tight text-zinc-50 sm:text-5xl lg:text-6xl">
        {words.map((w, i) => <Word key={i} word={w} i={i} total={words.length} progress={scrollYProgress} />)}
      </p>
    </section>
  );
};
